import React from "react";

import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";

import { useAuth } from "@/auth";
import { CHAT_ROUTE } from "@/common/static/routes.static";
import { unreadMessagesCountVar } from "@/variables/unreadMessagesCountVar";
import { useReactiveVar } from "@apollo/client";
import NoSSR from "@mpth/react-no-ssr";
import ContactIcon from "@whoppah/icons/24/Contact";

/**
 * Header chat action icon that navigates user to his/her chat.
 */
const HeaderChat = () => {
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();

  const unreadCount = useReactiveVar(unreadMessagesCountVar);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <NoSSR>
      <Link
        href={CHAT_ROUTE}
        prefetch={false}
        aria-label={t("header:nav-chats")}
        className="group flex cursor-pointer flex-col items-center rounded-[0.25rem] px-2 hover:bg-grey-50 md:space-y-1 md:p-2"
      >
        <div className="relative">
          <ContactIcon />
          {Boolean(unreadCount) && (
            <div className="absolute right-0 top-0 flex h-2 w-2 items-center justify-center rounded-full bg-attention-500" />
          )}
        </div>
        <span className="hidden font-body text-sm group-hover:text-attention-500 lg:inline">
          {t("header:nav-chats")}
        </span>
      </Link>
    </NoSSR>
  );
};

export default HeaderChat;
